import React, { useState, useCallback, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
  Table,
} from "reactstrap";
import Title from "../title";
import CreatableSelect from "react-select";
import { ComonIcons } from "../../contents/commonIcons";
import { useDispatch, useSelector } from "react-redux";

export const FormSecondStep = (formikProps) => {
  const { errors, touched, values, setFieldValue } = formikProps;

  const memberStore = useSelector((state) => state.member);
  const members = memberStore.allMembers;
  const modifiedMembers = members.map((m) => ({ value: m.id, label: m.name }));

  const [selectedMembers, setSelectedMembers] = useState([]);

  const all = { value: "all", label: "All" };
  modifiedMembers.unshift(all);

  const removeMember = (value, setFieldValue) => {

    let selectedArray = selectedMembers;
    selectedArray = selectedArray.filter(function (item) {
      return item.value !== value;
    });
    let listOfMembersId = selectedArray.map(
      (id) => id.value
    );
    setFieldValue("members", listOfMembersId);

    setSelectedMembers(selectedArray);
  };

  return (
    <div className="modal-body-content">
      <div className="">
        <div className="basic-info">
          <div className="members-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
            <div className="info-title">
              <Title title="Assign to Members" />
            </div>
            <div className="info">
              <Row>
                <Col md={12}>
                  <FormGroup className="custom-inputs mb-md-0">
                    <CreatableSelect
                      isClearable
                      className="form-control multi-select-search-block p-0 "
                      onChange={(m) => {
                        if (m.value == "all") {
                          const selectallMembers = members.map((m) => ({
                            value: m.id,
                            label: m.name,
                          }));

                          let selectList = [...selectallMembers];
                          const listOfSelectAllMembersId = selectList.map(
                            (id) => id.value
                          );

                          setFieldValue(
                            "members",
                            listOfSelectAllMembersId
                          );
                          setSelectedMembers(selectList);
                        } else {
                          let selectedArray = [...selectedMembers];
                          let found = selectedArray.some(
                            (el) => el.value === m.value
                          );
                          if (found) {
                            return;
                          }
                          selectedArray.push(m);
                          setSelectedMembers(selectedArray);
                          const listOfMembersId = selectedArray.map(
                            (id) => id.value
                          );
                          setFieldValue("members", listOfMembersId);
                        }
                      }}
                      options={modifiedMembers}
                      selectedMembers={members}
                    ></CreatableSelect>
                    <Label for="firstname" className="">
                      Type member name or search for it
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="table-main-block">
            <div className="wod-delete-table-wrapper">
              <Table striped responsive hover className="mb-0">
                <thead>
                  <th>Added Members</th>
                  <th></th>
                </thead>
                <tbody className="wod-delete-table">
                  {selectedMembers.map((value, index) => {
                    return (
                      <tr>
                        <td className="small">
                          {value.label}
                        </td>
                        <td className="text-capitalize text-right ">
                          <span
                            className="c-pointer"
                            onClick={() => removeMember(value.value, setFieldValue)}
                          >
                            {ComonIcons.delete}
                          </span>
                        </td>
                      </tr>
                    );
                  })}

                  <tr></tr>
                </tbody>
              </Table>
              {selectedMembers.length === 0 && (
                <div className="text-center text-uppercase add-wod-td mt-5 font-weight-bold">
                  No Data Available
                </div>
              )}
            </div>
          </div>
          {errors.members ? (
            <div className='invalid-feedback d-block'>{`${errors.members}`}</div>
          ) : null}
        </div>
      </div>
    </div>
  );
};